var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('div',{staticClass:"container"},[_c('div',[_c('el-header',{staticClass:"el-header"},[_c('HeaderBar')],1)],1),_c('div',{staticClass:"main-box"},[_c('router-view')],1),_c('div',[_c('Footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }